import { render, staticRenderFns } from "./AppointmentStep.vue?vue&type=template&id=4fe91af2"
import script from "./AppointmentStep.vue?vue&type=script&lang=ts"
export * from "./AppointmentStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports